import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'app-dcr',
  template: require('./dcr.component.html'),
  styles: []
})
export class DCRComponent implements OnInit {

  static parameters = [ToastrService]

  constructor(
    private toastr: ToastrService

  ) {

  }

  showSuccess() {
    this.toastr.success('DCR has been submitted successfully');
  }
  ngOnInit() {

  }

}
